import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://alyrujlpojezxmmcalqc.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFseXJ1amxwb2plenhtbWNhbHFjIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTY4ODM4ODc0MCwiZXhwIjoyMDAzOTY0NzQwfQ.NjRDTnVQ8dwK-uL_iLaoc0Fy0d9wo5IycCm_SEVBQTc'
export const supabase = createClient(supabaseUrl, supabaseKey)